import Vue from 'vue'
import Vuex from 'vuex'
import menus from "./modules/menus"

Vue.use(Vuex)

export default new Vuex.Store({
  state: sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')) : {
    token: '',
    sellData: {},
    sellDataP: [],
    code: ''
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      localStorage.setItem("token", token)
    },
    SET_SellData: (state, sellData) => {
      state.sellData = sellData
    },
    SET_SellDataP: (state, sellDataP) => {
      state.sellDataP = sellDataP
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
  },
  actions: {},
  modules: {
    menus
  }
})
